import { tokens, BLACK_700, LILAC_200, LILAC_400 } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getSuccessPageStyles = isLargeScreen => {
  return StyleSheet.create({
    container: {
      display: 'flex',
      flexDirection: isLargeScreen ? 'row' : 'column',
      backgroundColor: LILAC_200,
      borderRadius: 16
    },
    mobileContainer: {
      borderRadius: 16,
      backgroundColor: LILAC_200
    },
    statusCard: {
      justifyContent: 'center',
      alignItems: 'center',
      width: isLargeScreen ? '40%' : '',
      padding: tokens.spacing.SPACING_20
    },
    statusCardTitle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    title: {
      paddingBottom: tokens.spacing.SPACING_8,
      textAlign: 'center'
    },
    subtitle: {
      paddingBottom: tokens.spacing.SPACING_8
    },
    description: {
      color: BLACK_700,
      textAlign: 'center'
    },
    dividersection: Object.assign(Object.assign({
      backgroundColor: LILAC_400
    }, isLargeScreen && {
      width: 1,
      marginTop: tokens.spacing.SPACING_20,
      marginBottom: tokens.spacing.SPACING_20
    }), !isLargeScreen && {
      marginLeft: tokens.spacing.SPACING_20,
      marginRight: tokens.spacing.SPACING_20
    }),
    detailsSection: {
      padding: tokens.spacing.SPACING_20,
      width: isLargeScreen ? '60%' : ''
    },
    infoSubtitle: {
      color: BLACK_700,
      paddingBottom: tokens.spacing.SPACING_20
    },
    infoSection: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap'
    },
    collapsedSection: {
      width: '100%',
      paddingBottom: tokens.spacing.SPACING_20
    },
    collapsedArray: Object.assign({}, isLargeScreen && {
      flexDirection: 'row',
      flexWrap: 'wrap'
    }),
    collapsedCta: Object.assign({}, !isLargeScreen && {
      justifyContent: 'center',
      alignItems: 'center'
    }),
    infoSectionDetail: {
      minWidth: isLargeScreen ? 220 : 0,
      width: isLargeScreen ? '0%' : '100%',
      marginRight: isLargeScreen ? tokens.spacing.SPACING_12 : '',
      paddingBottom: tokens.spacing.SPACING_16
    },
    infoSectionKey: {
      color: BLACK_700
    },
    infoLink: Object.assign({
      display: 'flex',
      flexDirection: 'row'
    }, !isLargeScreen && {
      justifyContent: 'space-between'
    }),
    infoSectionValue: Object.assign({}, isLargeScreen && {
      paddingRight: tokens.spacing.SPACING_8
    }),
    buttonSection: {
      display: 'flex',
      flexDirection: isLargeScreen ? 'row' : 'column',
      paddingTop: tokens.spacing.SPACING_16,
      paddingBottom: isLargeScreen ? tokens.spacing.SPACING_20 : 0
    },
    actionCta: Object.assign({
      marginRight: tokens.spacing.SPACING_18
    }, !isLargeScreen && {
      marginBottom: tokens.spacing.SPACING_16
    }),
    navigateSection: {
      paddingBottom: tokens.spacing.SPACING_8
    },
    paddingTop: {
      paddingTop: tokens.spacing.SPACING_20
    },
    marginBottom: {
      marginBottom: tokens.spacing.SPACING_20
    }
  });
};